import { Text } from '@leroy-merlin-br/backyard-react-ui'

import Glyph from 'reactGarden/Glyph'

import * as S from './styled'

const HOME_DELIVERY = 'Entrega em domicílio'
const SERVICE = 'Serviços'
const PICKUP = 'Clique e retire'
const SMART_CHECKOUT = 'Retirada na Loja'

const HOME_DELIVERY_SHIFT_LABEL = 'Turno'
const PICKUP_SHIFT_LABEL = 'Horário'

const SHIPPING_LABEL = {
  [HOME_DELIVERY]: 'Data entrega',
  [SERVICE]: 'Previsão de realização',
  [PICKUP]: 'Data entrega',
  [SMART_CHECKOUT]: 'Data entrega'
}

const Shift = (props) => {
  if (!props.type) {
    return
  }

  const shiftLabel = props.type === HOME_DELIVERY
    ? HOME_DELIVERY_SHIFT_LABEL
    : PICKUP_SHIFT_LABEL

  return (
    <div className="title-shift color-default">
      <div className="small">{ shiftLabel }</div>
      <strong>{ props.shift }</strong>
    </div>
  )
}

const ShippingInfo = (type, date) =>
  ({
    label: SHIPPING_LABEL[type],
    forecast: type === SERVICE ? '3 dias após a entrega' : date
  })

const Title = ({ type, quantity, deliveryDate, shift, isOpen = false }) => (
  <S.Wrapper>
    <S.Type className="color-primary">
      <Text as="strong" size="mega" bold noMargin>{ type }</Text>
    </S.Type>

    <S.Quantity className="color-default">
      <Text as="div" size="kilo" noMargin>Itens</Text>
      <Text as="strong" size="kilo" bold noMargin>{ quantity }</Text>
    </S.Quantity>

    <S.Shipping className="color-default">
      <Text as="div" size="kilo" noMargin>{ ShippingInfo(type).label }</Text>
      <Text as="strong" size="kilo" bold noMargin>{ ShippingInfo(type, deliveryDate?.date).forecast }</Text>
    </S.Shipping>

    { shift && <Shift { ...{ type, shift } } /> }

    <S.Button className="color-primary">
      <Glyph glyph={isOpen ? 'double-arrow-up' : 'double-arrow-down'} />
    </S.Button>
  </S.Wrapper>
)

export default Title
